import useActiveOrDefaultChain from 'src/common/hooks/web3/useActiveOrDefaultChain'
import { useMemo } from 'react'
import staticConfig from '..'
import { networksEnvironments } from '../networks'

const useConfig = () => {
  const chain = useActiveOrDefaultChain()

  const config = useMemo(() => {
    const networkEnv = networksEnvironments[chain.id]

    return {
      subgraphUrls: networkEnv.subgraphUrls,
      contractsAddresses: networkEnv.contracts,
      tokensAddresses: networkEnv.tokens,
      ...staticConfig,
    }
  }, [chain.id])

  return config
}

export default useConfig
